import Faq from '../../components/Faq';
import { scrollPageTo } from '../../utils';
let view = null;

import BackgroundImpressionVideo from '../../components/BackgroundImpressionVideo';
import BackgroundImpressionImage from '../../components/BackgroundImpressionImage';

class Information {
	constructor(container) {
		this.container = container;
		this.breakpoint = window.matchMedia("(orientation: portrait)");
	}

	init() {

		// DOM Elements
		this.sections = this.container.querySelectorAll('[data-information-section]');

		// Scroll To Section
		this.sectionLinks = this.container.querySelectorAll('[data-section-link]');
		this.sectionLinks.forEach(link => {
			const speed = 1000;
			const target = this.container.querySelector(link.getAttribute('href'));

            if(!target) {
                return;
            }

			link.addEventListener('click', e => {
                e.preventDefault();
				scrollPageTo(target, speed, 1);
			});
		});

		// Scroll Listener
		this.boundHandleScroll = this.handleScroll.bind(this);
		document.addEventListener('scroll', this.boundHandleScroll);
		this.handleScroll();

		// FAQ
		const faqs = this.container.querySelectorAll('[data-faq]');
		faqs.forEach(faq => {
			new Faq(faq);
		});


		// Impressions
		this.impressions = [];

		if (this.breakpoint.matches === false) { // Desktop

			const impressionVideosDesktop = this.container.querySelectorAll('[data-impression-video-desktop]');
			if(impressionVideosDesktop) {
				impressionVideosDesktop.forEach(elm => {
					if(!this.videoError) {
						const video = new BackgroundImpressionVideo(elm, 'desktop');
						this.impressions.push(video);
					}
				});
			}
			const impressionImagesDesktop = this.container.querySelectorAll('[data-impression-image-desktop]');
			if(impressionImagesDesktop) {
				impressionImagesDesktop.forEach(elm => {
					const image = new BackgroundImpressionImage(elm, 'desktop');
					this.impressions.push(image);
				});
			}


		} else { // Mobile

			const impressionVideosMobile = this.container.querySelectorAll('[data-impression-video-mobile]');
			if(impressionVideosMobile) {
				impressionVideosMobile.forEach(elm => {
					if(!this.videoError) {
						const video = new BackgroundImpressionVideo(elm, 'mobile');
						this.impressions.push(video);
					}
				});
			}
			const impressionImagesMobile = this.container.querySelectorAll('[data-impression-image-mobile]');
			if(impressionImagesMobile) {
				impressionImagesMobile.forEach(elm => {
					const image = new BackgroundImpressionImage(elm, 'mobile');
					this.impressions.push(image);
				});
			}

		}

	}


	handleScroll() {
		let closest = 0;
		let activeSection = this.sections[0];
        this.sections.forEach((section) => {
			const rect = section.getBoundingClientRect();
			if(rect.top>0) {
				return;
			}

			if (closest === 0) {
				closest = Math.abs(rect.top);
				activeSection = section;
			} else if (Math.abs(rect.top) > 0 && Math.abs(rect.top) <= Math.abs(closest)) {
				closest = Math.abs(rect.top);
				activeSection = section;
			} else if (Math.abs(rect.top) < 0 && - Math.abs(rect.top) < Math.abs(closest)) {
				closest = Math.abs(rect.top);
				activeSection = section;
			}

        });

		// Set Active Section
        this.sectionLinks.forEach((link) => {
            link.classList.remove('is-active');
        });

        if(activeSection) {
            const activeID = activeSection.getAttribute('id');
            const activeLink = this.container.querySelector('[href="#'+activeID+'"]');
            activeLink.classList.add('is-active');
        }

    }

	destroy() {
		if (this.impressions) {
			this.impressions.forEach((impression) => {
				if (typeof impression.destroy !== 'function') {
					return;
				}
				impression.destroy();
			});
			this.impressions = [];
		}
	}
}

export default {
	namespace: 'template-information',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Information(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
